import { render, staticRenderFns } from "./OrderAddOns.vue?vue&type=template&id=2c990c46&scoped=true&"
import script from "./OrderAddOns.vue?vue&type=script&lang=js&"
export * from "./OrderAddOns.vue?vue&type=script&lang=js&"
import style0 from "./OrderAddOns.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderAddOns.vue?vue&type=style&index=1&id=2c990c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c990c46",
  null
  
)

component.options.__file = "OrderAddOns.vue"
export default component.exports